// scoring.js

export function calculateScore(userPicks, actualPicks) {
    let totalScore = 0;
  
    userPicks.forEach((userPick, index) => {
      const actualPick = actualPicks.find(p => p.player === userPick.player);
      if (!actualPick) return;
  
      let score = 0;
  
      if (userPick.team === actualPick.team) {
        score += 5;
      }
  
      const slotDiff = Math.abs(userPick.pickNumber - actualPick.pickNumber);
      if (slotDiff === 0) {
        score += 5;
      } else if (slotDiff === 1) {
        score += 4;
      } else if (slotDiff === 2) {
        score += 3;
      } else if (slotDiff === 3) {
        score += 2;
      } else if (slotDiff === 4) {
        score += 1;
      }
  
      totalScore += score;
    });
  
    return totalScore;
  }
  